export const DEFAULT_DATE = new Date(2020, 5, 30);
export const DATE_FORMAT = 'DD/MM/YYYY';
